import { createAsyncThunk } from '@reduxjs/toolkit';
import { REDUX_ACTION, selectApi, setReduxAction } from '@socialive/common';

const completeMultipartUpload = createAsyncThunk(
  'uploads/completeMultipartUpload',
  async ({ bucket, key, uploadId, partETags, trigger }, { dispatch, getState }) => {
    const api = selectApi(getState());
    if (!api) throw new Error('API is required');

    return api(`/s3-secure/multipart/complete/${bucket}/${key}`, {
      method: 'POST',
      data: {
        uploadId,
        partETags,
      },
    });
  }
);

setReduxAction(REDUX_ACTION.COMPLETE_MULTI_PART_UPLOAD, completeMultipartUpload);

export default completeMultipartUpload;
